import resourcesCart from './resourcesCart';
import SubmittalBuilder from './submittalBuilder';
import updateCartCount from './updateCartCount';
import selectors from './selectors';
import modalView from './modalView';

// On ready.
(($) => {

	const { cart } = selectors;

	const {
		initSearchEvents,
		initResourceLangToggle,
		initAddToCollectionBehavior,
		initDataTables,
	} = resourcesCart;

	const {
		processPendingPDFsQueue,
		processReadyPDFsQueue,
		startMergedPDFAsyncDownload,
	} = SubmittalBuilder;

	processPendingPDFsQueue();
	processReadyPDFsQueue();
	window.startMergedPDFAsyncDownload = startMergedPDFAsyncDownload;

	// Update the cart count badge.
	updateCartCount();

	// Init the cart search events.
	initSearchEvents();

	initResourceLangToggle();

	// Add the add to cart functionality.
	initAddToCollectionBehavior();

	initDataTables();

	if (modalView) {
		// Render the instance of the modal.
		const markup = modalView.render().el;

		$(cart.wrapper).html(markup);

		// If we have the `gf_` url hash prefix means we had a form submit.
		const isFormSubmission = window.location.hash
			&& window.location.hash.indexOf('gf_') > -1;

		if (isFormSubmission) {
			// So we open the form view.
			modalView.openAt(1);
		}

		modalView.maybeShowEmptyCart();
	}

	$(document).on('gform_confirmation_loaded', (event, formId) => {
		if (parseInt(formId, 10) === parseInt(vtcSBVars.form_id, 10)) {
			modalView.clearCart('all');
		}
	});

})(jQuery);
